import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createPaymentReconMain,
  fetchAllPaymentReconMains,
  updatePaymentReconMain,
  fetchOnePaymentReconMain,
  deletePaymentReconMain,
  fetchLatestPaymentReconMain,
  fetchGenerateReconId,
  generatePaymentReconReport,
} from "services/paymentreconmain";

export const useGenerateReconId = (params = {}) => {
  const query = useQuery({
    queryKey: ["generate-reconid", params],
    queryFn: () => {
      return fetchGenerateReconId(params);
    },
    staleTime: 0,
  });
  return query;
};

export const useAllPaymentReconMains = (filters = {}) => {
  const query = useQuery({
    queryKey: ["all-PaymentRecons", filters],
    queryFn: () => {
      return fetchAllPaymentReconMains(filters);
    },
  });
  return query;
};

export const useLatetsPaymentReconMain = () => {
  const query = useQuery({
    queryKey: ["latest-PaymentRecons"],
    queryFn: () => {
      return fetchLatestPaymentReconMain();
    },
  });
  return query;
};

export const useOnePaymentReconMain = (id) => {
  const query = useQuery({
    queryKey: ["one-PaymentRecon", id],
    queryFn: () => {
      if (id) {
        return fetchOnePaymentReconMain(id);
      }
    },
  });
  return query;
};

export const useCreatePaymentReconMain = () => {
  const queryClient = useQueryClient();
  
  const query = useMutation({
    mutationFn: (data) => createPaymentReconMain(data),
    onSuccess: () => {
      // Invalidate queries to refetch
      queryClient.invalidateQueries({ queryKey: ["all-PaymentRecons"] });
      queryClient.invalidateQueries({ queryKey: ["latest-PaymentRecons"] });
    },
  });
  return query;
};

export const useUpdatePaymentReconMain = () => {
  const queryClient = useQueryClient();
  
  const query = useMutation({
    mutationFn: ({ id, data }) => updatePaymentReconMain(id, data),
    onSuccess: () => {
      // Invalidate queries to refetch
      queryClient.invalidateQueries({ queryKey: ["all-PaymentRecons"] });
      queryClient.invalidateQueries({ queryKey: ["one-PaymentRecon"] });
    },
  });
  return query;
};

export const useDeletePaymentReconMain = () => {
  const queryClient = useQueryClient();
  
  const query = useMutation({
    mutationFn: (id) => deletePaymentReconMain(id),
    onSuccess: () => {
      // Invalidate queries to refetch
      queryClient.invalidateQueries({ queryKey: ["all-PaymentRecons"] });
    },
  });
  return query;
};

export const useGeneratePaymentReconReport = () => {
  const query = useMutation({
    mutationFn: (params) => generatePaymentReconReport(params),
  });
  return query;
};
